<script lang="ts" setup>
import { usePaneStore } from '#layers/ui/public';
import WorkspaceChromeEndPane from './WorkspaceChromeEndPane.vue';

const paneStore = usePaneStore();
</script>

<template>
	<WorkspaceChromeEndPane
		:key="!paneStore.currentPanel?.component ? 'no-panel' : 'with-panel'"
		v-model:size="paneStore.panelSize"
		v-model:collapsed="paneStore.panelSplitPanelCollapsed"
		v-model:drawer-open="paneStore.panelDrawerVisible"
		class="min-h-0 grow"
		:split="paneStore.panelUseSplitPanel"
	>
		<slot />

		<template v-if="paneStore.currentPanel?.component" #pane>
			<component :is="paneStore.currentPanel.component" />
		</template>
	</WorkspaceChromeEndPane>
</template>
